import { useTranslation } from 'react-i18next';

import InputErrorIcon from '@crm/shared/assets/icons/input-error.svg?react';
import { getCrmTariffPaymentUrl } from '@crm/shared/config';
import { cn } from '@crm/shared/lib';
import { Button, SvgIcon } from '@crm/shared/ui';
import { getRemainingDescription, getTariffState } from '@entities/tariff';

import { openTariffPayment } from '../lib/openTariffPayment';

import type { TTariff } from '@entities/tariff';

type TTariffDataProps = {
    tariffData: TTariff;
    onPaymentOpen: () => void;
};

export const TariffData = ({ tariffData, onPaymentOpen }: TTariffDataProps) => {
    const { t } = useTranslation();
    const tariffState = getTariffState(tariffData);
    const descriptions = {
        unlimited: t('crm.userProfileMenu.tariff.unlimited'),
        suspended: t('crm.userProfileMenu.tariff.suspended'),
        autoRenewal: t('crm.userProfileMenu.tariff.autoRenewal'),
    };
    const description =
        tariffState.type === 'remaining'
            ? getRemainingDescription(tariffState, t)
            : descriptions[tariffState.type];
    const handlePaymentClick = () => {
        onPaymentOpen();
        openTariffPayment(getCrmTariffPaymentUrl());
    };

    return (
        <div className="flex flex-col px-3.25 py-2.75">
            <span className="text-xs">
                {tariffData.title ?? t('crm.userProfileMenu.unknownTariff')}
            </span>
            <span
                className={cn(
                    'flex items-center gap-2 text-[10px]',
                    tariffState.isWarning ? 'text-smtr-main-red-100' : 'text-smtr-main-tertiary-100'
                )}
            >
                {description}
                {tariffState.isWarning && (
                    <SvgIcon icon={InputErrorIcon} className="size-3.5 shrink-0" />
                )}
            </span>
            {tariffState.isWarning ? (
                <Button
                    type="button"
                    className="mt-2 size-fit self-start rounded-[2.25px] py-[5px]"
                    aria-haspopup="dialog"
                    onClick={handlePaymentClick}
                >
                    {t('paymentTariffManager.extend')}
                </Button>
            ) : null}
        </div>
    );
};
